export const getOverviewLinkedType = (type) => {
    if (type === 'third') {
        return {
            type: window.sellsyapp.$store?.getters?.identity?.isCorporation
                ? 'company'
                : 'individual',
            apiEndpoint: window.sellsyapp.$store?.getters?.identity?.isCorporation
                ? 'companies'
                : 'individuals',
        };
    } else if (type === 'people') {
        return { type: 'contact', apiEndpoint: 'contacts' };
    }
};
